import type {PreferenceType} from '@mattermost/types/preferences';
import {Preferences} from 'mattermost-redux/constants';
import type {DirectChannelShowPreference} from '../types';

export function isDirectChannelShowPreference(preference: PreferenceType): preference is DirectChannelShowPreference {
    return preference.category === Preferences.CATEGORY_DIRECT_CHANNEL_SHOW;
}
